import { render, staticRenderFns } from "./JumpsellerOAuthCallbackView.vue?vue&type=template&id=648dc39e&scoped=true&lang=pug"
import script from "./JumpsellerOAuthCallbackView.vue?vue&type=script&lang=js"
export * from "./JumpsellerOAuthCallbackView.vue?vue&type=script&lang=js"
import style0 from "./JumpsellerOAuthCallbackView.vue?vue&type=style&index=0&id=648dc39e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648dc39e",
  null
  
)

export default component.exports